import { ApiPromise, WsProvider } from "@polkadot/api";
import { AccountInfo } from "@polkadot/types/interfaces";
import { useMutation } from "@tanstack/react-query";
import settings from "../settings.json";
import { FormModel } from "./types";
import { toUnits } from "thirdweb";
import { decimals } from "./constants";

export const useLiberlandVerifier = () => {
    return useMutation({
        mutationFn: async (formModel: FormModel) => {
            const provider = new WsProvider(settings.ws);
            const api = await ApiPromise.create({ provider: provider });
            const { data } = await api.query["system"]!["account"]!(settings.seller.ll) as AccountInfo;
            const free = data.free.toBigInt();
            const transfer = api.tx["balances"]!["transfer"]!(formModel.recipient, toUnits(formModel.toAmount, decimals.Liberland[formModel.token]));
            const paymentInfo = await transfer.paymentInfo(settings.seller.ll);
            const partialFee = BigInt(paymentInfo.partialFee.toString());
            const result = free > partialFee * 2n;
            await api.disconnect();
            return result;
        },
    });
};